import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        about: 'About Us',
        services: 'Services',
        industries: 'Industries',
        working_model: 'Working Model',
        legal: 'Legal & Compliance',
        contact: 'Contact',
      },
      hero: {
        headline: 'Recovery. Resolve. Rebuild',
        subheadline: 'Corporate Debt Recovery & NPA Resolution Experts Across India',
        cta_consultation: 'Request Confidential Consultation',
        cta_download: 'Download Corporate Profile',
      },
      common: {
        learn_more: 'Learn More',
        view_all: 'View All',
        contact_us: 'Contact Us',
        read_more: 'Read More',
        submit: 'Submit',
        loading: 'Loading...',
      },
    },
  },
  hi: {
    translation: {
      nav: {
        home: 'होम',
        about: 'हमारे बारे में',
        services: 'सेवाएं',
        industries: 'उद्योग',
        working_model: 'कार्य मॉडल',
        legal: 'कानूनी और अनुपालन',
        contact: 'संपर्क करें',
      },
      hero: {
        headline: 'संरचित वसूली। रणनीतिक समाधान। विश्वसनीय वित्तीय परिणाम।',
        subheadline: 'भारत भर में कॉर्पोरेट ऋण वसूली और एनपीए समाधान विशेषज्ञ',
        cta_consultation: 'गोपनीय परामर्श का अनुरोध करें',
        cta_download: 'कॉर्पोरेट प्रोफाइल डाउनलोड करें',
      },
      common: {
        learn_more: 'और जानें',
        view_all: 'सभी देखें',
        contact_us: 'संपर्क करें',
        read_more: 'और पढ़ें',
        submit: 'जमा करें',
        loading: 'लोड हो रहा है...',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
